import { Card, Image, CardSectionProps } from "@mantine/core"
import { useChatPostAttachmentApi } from "../../../../../../attachment-api/chatPostAttachmentApi"
import { ChatPostAttachmentDto } from "../../../../../../@client/Theasoft_ApiServer_Chat"

export function PostAttachments({
  attachments,
  chatPostId,
  cardSectionProps,
}: {
  attachments: ChatPostAttachmentDto[]
  chatPostId: number
  cardSectionProps?: CardSectionProps
}) {
  const chatPostAttachmentAPI = useChatPostAttachmentApi()

  return (
    <Card.Section
      h={260}
      style={{ overflow: "hidden", flexShrink: 0 }}
      {...cardSectionProps}
    >
      <Image
        mih={0}
        w="100%"
        h={"100%"}
        fit="contain"
        src={chatPostAttachmentAPI.getFileUrl(
          attachments[0].attachmentId,
          chatPostId
        )}
        alt="Feed post"
      />
    </Card.Section>
  )
}
